import { render, staticRenderFns } from "./StCourseZu.vue?vue&type=template&id=0bef8f4a&scoped=true"
import script from "./StCourseZu.vue?vue&type=script&lang=js"
export * from "./StCourseZu.vue?vue&type=script&lang=js"
import style0 from "./StCourseZu.vue?vue&type=style&index=0&id=0bef8f4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bef8f4a",
  null
  
)

export default component.exports